export default __webpack_public_path__ + "static/media/miguel-lopes-4.14b81e6b.jpg";